// extracted by mini-css-extract-plugin
export default {"hexagonList":"hexagonList___u2xki"};